import React from "react";
import { Route } from "react-router-dom";
import AccesoDenegado from "../../../paginas/Error/AccesoDenegado";
import Autorizador from "../Autorizador/Autorizador";

const ProtectedRoute = ({
  path,
  component: Component,
  data,
  render,
  tieneAccesoPermitido = "true",
  ...rest
}) => {
  if (!tieneAccesoPermitido) {
    return <Route component={AccesoDenegado} />;
  }

  return (
    <Autorizador>
      <Route
        {...rest}
        render={(props) => {
          return Component ? <Component {...props} /> : render(props);
        }}
      />
    </Autorizador>
  );
};

export default ProtectedRoute;
